import { useContext } from 'react';
import { MdArrowForward, MdCheckCircle } from 'react-icons/md';
import { AppContext } from '../App';
import { hospiumProducts } from '../HospiumContent';
import logoIcon from '../assets/logo_icon.png';

export default function ProductPreviewSection() {
  const appContext = useContext(AppContext);

  return (
    <section className="HospiumSection HospiumProductPreview">
      <div className="container">
        <div className="HospiumSectionHeading">
          <div><span className="HospiumKicker">Four focused products</span><h2>One Hospium ecosystem</h2></div>
          <button className="btn btn-outline-primary btn-padded btn-rounded" onClick={() => appContext.navTo({ item: 'services' })}>Explore all products <MdArrowForward /></button>
        </div>
        <div className="row g-4">
          {hospiumProducts.map((product) => (
            <div className="col-12 col-lg-6" key={product.key}>
              <article className="HospiumProductPreviewCard">
                <div className="HospiumProductImage" style={{ backgroundImage: `url(${product.image})` }}>
                  <img src={logoIcon} alt="Hospium" />
                </div>
                <div className="HospiumProductCopy">
                  <span>{product.label}</span><h3>{product.name}</h3><p>{product.short}</p>
                  <div>{product.points.map((point) => <small key={point}><MdCheckCircle /> {point}</small>)}</div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
